import React from 'react';
import {
  PlatformFloatingRail,
} from '../platform/subpages';
import { SolutionAdvantages } from './SolutionAdvantages';
import { SolutionCommercialBenefitOrbit } from './SolutionCommercialBenefitOrbit';
import { SolutionClosingCta } from './SolutionClosingCta';
import { SolutionEduTabs } from './SolutionEduTabs';
import { SolutionFaqs } from './SolutionFaqs';
import { SolutionHero } from './SolutionHero';
import { SolutionTrustedBy } from './SolutionTrustedBy';
import { solutionPageExtras } from './solutionPageExtras';
import type { SolutionSubpageConfig } from './types';

export interface SolutionSubPageLayoutProps {
  config: SolutionSubpageConfig;
  children: React.ReactNode;
}

export const SolutionSubPageLayout: React.FC<SolutionSubPageLayoutProps> = ({
  config,
  children,
}) => {
  const extras = config.pageExtras ?? solutionPageExtras[config.slug];

  return (
  <div
    className={`io-site solution-page platform-subpage solution-subpage solution-subpage--${config.slug} platform-subpage--${config.slug}`}
  >
    <SolutionHero config={config} />
    <SolutionTrustedBy trustedBy={config.premium.trustedBy} />
    <SolutionEduTabs education={config.premium.education} />
    {config.slug === 'commercial-lighting' && extras.benefitOrbit ? (
      <SolutionCommercialBenefitOrbit orbit={extras.benefitOrbit} />
    ) : (
      <SolutionAdvantages advantages={config.advantages} />
    )}
    {children}
    {config.faqs ? <SolutionFaqs faqs={config.faqs} /> : null}
    {config.slug !== 'commercial-lighting' ? (
      <div id="get-started" className="platform-sub-get-started">
        <SolutionClosingCta closing={config.closing} />
      </div>
    ) : null}
    <PlatformFloatingRail hideUntilPastHero />
  </div>
  );
};
